import React, { Component } from "react";
import DataCaptureService from "@services/DataCaptureService";
import ProfileManagementService from "@services/ProfileManagementService";
import FieldworkManagementService from "@services/FieldworkManagementService";
import SurveyService from "@services/SurveyService";
import DropDownMenu from '@components/DropDownMenu';
import SpinnerModal from "@components/SpinnerModal";
import TableWidget from '@components/TableWidget';
import { useDialog } from 'react-st-modal';
import {
    Card,
    CardContent,
    FormControl,
    Grid,
} from '@mui/material'
import styles from './interactionhistorydialog.module.css';

class InteractionHistoryDialog extends Component {
    state = {
        loading: true,
        interactionTypes: [],
        returnTypes: [],
        surveysUsers: [],
        interactionHistory: [],
        surveyCycles: [],
        selectedSurveyCycle: process.env.REACT_APP_CURRENT_SURVEY_CYCLE,
        surveyCyclesLoading: false
    }

    INTERACTION_HISTORY_SURVEY_CYCLES = 5;

    constructor(props) {
        super(props);
    }

    async componentDidMount() {
        this.setState({ loading: true });

        this.reloadAllSurveyCycles();

        const sourcesOfData = await DataCaptureService.getLookups();

        const surveysUsers = await ProfileManagementService.getAllSurveysUsers();
        this.setState({ surveysUsers: surveysUsers });

        let interactionTypes = [];
        sourcesOfData.filter((lookup) => (lookup.type.includes('_INTERACTION_'))).map(item => {
            interactionTypes.push({ key: item.varenum, value: item.name });
        });

        let returnTypes = [];
        sourcesOfData.filter((lookup) => (lookup.type.includes('INTERACTION_RETURN_'))).map(item => {
            returnTypes.push({ key: item.varenum, value: item.name });
        });

        this.reloadInteractionHistory(this.state.selectedSurveyCycle);

        this.setState({ interactionTypes: interactionTypes });
        this.setState({ returnTypes: returnTypes });

        this.setState({ loading: false });
    }

    async reloadInteractionHistory(surveyCycleId) {
        const savedInteractionHistory = await FieldworkManagementService.getInteractionsByOrganisationIdAndSurveyCycleId(this.props.organisationStatus.organisationId, surveyCycleId);
        if (savedInteractionHistory !== undefined && savedInteractionHistory !== null && savedInteractionHistory !== '') {
            this.setState({ interactionHistory: savedInteractionHistory });
        }
    }

    async reloadAllSurveyCycles() {
        this.setState({ surveyCyclesLoading: true });
        try {
            const surveyCycles = await SurveyService.getAllSurveyCycles();
            surveyCycles.filter(surveyCycle => surveyCycle.id <= process.env.REACT_APP_CURRENT_SURVEY_CYCLE).sort((a, b) => a.id > b.id ? -1 : 1).slice(0, this.INTERACTION_HISTORY_SURVEY_CYCLES).forEach(surveyCycle => {
                if (!this.state.surveyCycles.some(item => item.id === surveyCycle.id)) {
                    this.state.surveyCycles.push({ key: surveyCycle.id, value: surveyCycle.name });
                }
            });
        } catch (ex) {
            // console.log('Network error loading survey cycles');
        }
        this.setState({ surveyCyclesLoading: false });
    }

    getContactNameByContactStateId(contactStateId) {
        let orgContacts = this.props.organisationStatus.organisationContactList;

        let contact = (contactStateId !== null && orgContacts !== undefined && orgContacts !== null && orgContacts.length > 0)
            ? orgContacts.filter(contact => contact.contactStateId == contactStateId)[0]
            : null;

        return contact !== null ? (contact.title + ' ' + contact.firstname + ' ' + contact.lastname) : 'No selected contact';
    }

    getSurveysUserNameById(userId) {
        let name = (this.state.surveysUsers.filter(surveysUser => surveysUser.id == userId)[0].firstname + ' ' + this.state.surveysUsers.filter(surveysUser => surveysUser.id == userId)[0].lastname);
        return name;
    }

    handleChangedValue = (evt) => {
        switch (evt.target.name) {
            case 'surveyCycle': {
                this.setState({ selectedSurveyCycle: evt.target.value });
                this.reloadInteractionHistory(evt.target.value);
                break;
            }
            default: {
                break;
            }
        }
    }

    render() {
        if (this.state.loading === true) {
            return <SpinnerModal settings={true} />
        } else {

            let organisationContacts = [];

            this.props.organisationStatus.organisationContactList.map(item => {
                organisationContacts.push({ key: item.contactId, value: this.getContactNameByContactStateId(item.contactStateId) });
            });

            let contact = this.props.organisationStatus !== undefined && this.props.organisationStatus !== null && this.props.organisationStatus.filledInBy !== undefined && this.props.organisationStatus.filledInBy !== null
                ? this.props.organisationStatus.organisationContactList.filter(contact => contact.contactStateId == this.props.organisationStatus.filledInBy)[0]
                : null;

            let columns = [
                { label: "Interaction Date", name: "interactionDate" },
                { label: "Interacting Fieldworker", name: "interactingFieldworker" },
                { label: "Contact", name: "interactionContact" },
                { label: "Interaction Type", name: "interactionType" },
                { label: "Return Type", name: "returnType" },
                { label: "Comment", name: "comment" },
            ]

            let tableData = [];

            this.state.interactionHistory.sort((a, b) => a.id < b.id ? 1 : -1).map(interaction => {
                let row = {
                    interactionDate: new Date(interaction.interactionDate).toLocaleString('en-ZA'),
                    interactingFieldworker: this.getSurveysUserNameById(interaction.interactedBy),
                    interactionContact: interaction.contact?.title + ' ' + interaction.contact?.firstname + ' ' + interaction.contact?.lastname,
                    interactionType: this.state.interactionTypes.filter(i => i.key == interaction.interactionType)[0].value,
                    returnType: this.state.returnTypes.filter(i => i.key == interaction.returnType)[0]?.value,
                    comment: interaction.comment,
                }
                tableData.push(row);
            });

            let options = {
                selectableRowsHideCheckboxes: true,
            };

            return <DialogWrapper {...this.props} onClick={(evt) => this.props.nextButton.onClick(evt, this.state.organisationStatus)} content={
                <React.Fragment>
                    <div className={styles.featuredInteractionHistoryDialogItem}>
                        <div className={styles.featuredItem} >
                            <span><h1 className={styles.featuredTitleHeader}>{'Organisation Details'}</h1></span>
                            <div className={styles.featuredItem} >
                                {'Organisation name : ' + ((this.props.organisationStatus.parentOrganisationStateName !== undefined && this.props.organisationStatus.parentOrganisationStateName !== null && this.props.organisationStatus.parentOrganisationStateName !== '') ? this.props.organisationStatus.parentOrganisationStateName + ' / ' : '') + this.props.organisationStatus.organisationStateName}<br />
                                {'Receipt number : ' + (this.props.organisationStatus.receiptNumber !== undefined && this.props.organisationStatus.receiptNumber !== null ? this.props.organisationStatus.receiptNumber : 'Not received')}<br />
                                {'Researcher : ' + this.props.organisationStatus.selectedResearcher}<br />
                                {'Survey Critical Firm/Unit : ' + ((this.props.organisationStatus.surveyCritical !== undefined && this.props.organisationStatus.surveyCritical !== null && this.props.organisationStatus.surveyCritical === true) ? 'Yes' : 'No')}<br />
                            </div>
                        </div>
                        <div className={styles.featuredItem} >
                            <span><h1 className={styles.featuredTitleHeader}>{'Respondent Details'}</h1></span>
                            <div className={styles.featuredItem} >
                                {'Selected Contact : ' + this.getContactNameByContactStateId(this.props.organisationStatus.filledInBy)}<br />
                                {'Email : ' + ((contact !== undefined && contact !== null) ? contact.email : 'Not available')}<br />
                            </div>
                        </div>
                        <div className={styles.featuredItem} >
                            <span><h1 className={styles.featuredTitleHeader}>{'Interaction History'}</h1></span>
                            <Grid item xs={12}>
                                <Card>
                                    <CardContent>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <FormControl fullWidth>
                                                    <DropDownMenu
                                                        name={'surveyCycle'}
                                                        label={'Survey Cycle'}
                                                        value={this.state.selectedSurveyCycle}
                                                        onChange={(evt) => this.handleChangedValue(evt)}
                                                        showKeys={false}
                                                        menuOptions={this.state.surveyCycles.sort((a, b) => a.key > b.key ? -1 : 1)}
                                                        required
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                                <Card>
                                    <CardContent>
                                            <Grid item xs={6}>
                                                {this.state.interactionHistory !== undefined && this.state.interactionHistory !== null && this.state.interactionHistory.length > 0
                                                    ? <TableWidget
                                                        titleSeperator={false}
                                                        rowsPerPage={5}
                                                        rows={tableData}
                                                        columns={columns}
                                                        options={options}
                                                    />
                                                    : <div className={styles.featuredItem} >
                                                        <span>
                                                            <h1 className={styles.featuredTitleHeader}>{'Interaction History'}</h1>
                                                        </span>
                                                        <div className={styles.featuredItem}>No interaction history for this organisation during the selected survey cycle</div>
                                                    </div>
                                                }
                                            </Grid>
                                    </CardContent>
                                </Card>
                            </Grid><br />


                        </div>
                        {/* </div> */}
                    </div>
                </React.Fragment>
            }
            />
        }
    }

}
export default InteractionHistoryDialog;

function DialogWrapper(props) {
    const dialog = useDialog();

    return (
        <div>
            <br />
            <div>
                {props.content}
            </div>
            <div>
                {props.backButton !== undefined && props.backButton !== null
                    ? <button type="button" className="btnBack"
                        onClick={() => {
                            dialog.close(false);
                        }}
                    >
                        {props.backButton.text}
                    </button>
                    : <div />
                }
                {props.nextButton !== undefined && props.nextButton !== null
                    ? <button type="button" className="btnNext"
                        onClick={(evt) => {
                            props.onClick(evt);
                            dialog.close(true);
                        }}
                    >
                        {props.nextButton.text}
                    </button>
                    : <div />
                }
            </div>
        </div>
    );
}

